import {
  Chip,
  FormControl,
  Grid,
  Badge,
  Divider,
  Paper,
  Button,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Snackbar from "../../snackbar";
import { textFieldStyles } from "./styles";
import moment from "moment";
import { Link } from "react-router-dom";
import LabelForm from "../../../partials/labelForm";
import TextForm from "../../../partials/textForm";
import PriceFormat from "../../../partials/priceFormat";
import classNames from "classnames";

class EditNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: 0,
      data: {},
      employeeInfo: [],
    };
    this.handleDialog = this.handleDialog.bind(this);
  }
  async componentDidMount() {
    this.setState({ data: this.props.data });
    if (this.props.data.actionHistory.length) {
      let userCodeArray = this.props.data.actionHistory.map((ele) => {
        return ele.userCode;
      });
      let check = await this.props.employeeDispatch.getInfoEmployeeFromOrder(
        userCodeArray
      );
      if (check.code === 1) this.setState({ employeeInfo: check.data });
    }
  }
  handleChange = () => {};

  handleSelectSuportChange = (value) => {
    let data = this.state.data;
    data.support = value;
    this.setState({ data }, function () {});
  };

  handleSubComponentChange = (name, value) => {
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };

  onChange = (value) => {
    // eslint-disable-line
    let data = this.state.data;
    data.isActive = value ? 1 : 0;
    this.setState({ data });
  };
  handleDialog() {
    this.mDialog.handleDialogOpen();
  }
  handleSubmit = async () => {
    let { t } = this.props;
    let check = await this.props.orderDispatch.updateNoteOrder(this.state.data);
    this.mDialog.handleDialogClose();
    if (check.code === 1)
      this.mSnackbar.handleClick(t("orders_editnote_update_successfully"));
    else
      this.mSnackbar.handleClick(
        t("orders_editnote_update_unsuccessfully") + " " + check.message,
        "error"
      );
  };
  getInfoEmployee = (userCode) => {
    let employeeInfo = this.state.employeeInfo.filter(
      (ele) => ele.userCode === userCode
    );
    if (employeeInfo.length) return employeeInfo[0];
  };
  changeFormat(datetime) {
    return moment(datetime).format("DD/MM/YYYY hh:mm:ss A");
  }
  render() {
    const { classes, t, match } = this.props;
    if (Object.keys(this.state.data).length > 0) {
      let _this = this;
      let valueDiscount =
        _this.state.data.discount.type === "percent"
          ? _this.state.data.discount.value * 100 + " %"
          : _this.state.data.discount.type === "value"
          ? `${_this.state.data.discount.value} ${this.props.currencyCode}`
          : "Không áp dụng";
      let actionHistory = _this.state.data.actionHistory.reverse();
      let moneyReceived = 0;
      let moneyChange = 0;
      if (Array.isArray(_this.state.data.payment)) {
        _this.state.data.payment.forEach((e) => {
          moneyReceived += e.moneyReceived;
          moneyChange += e.moneyChange;
        });
      }
      moneyChange += ` ${this.props.currencyCode}`;
      moneyReceived += ` ${this.props.currencyCode}`;
      return (
        <Paper className={classes.container} square={true}>
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Grid container spacing={4}>
            <Grid item xs={12} sm={10} md={10}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_item")} />
                <div className={classes.actionForm}>
                  {!_this.state.data.item.length ? (
                    <TextForm
                      label={t("orders_editnote_not_any_item_assigned")}
                    />
                  ) : (
                    _this.state.data.item.map((item, index) => {
                      if (item.itemType === "memberCard")
                        return (
                          <Chip
                            label={
                              t("membercard") +
                              " | " +
                              item.itemName +
                              " | " +
                              item.itemPrice
                            }
                            color="default"
                          />
                        );
                      else
                        return (
                          <Badge
                            className={classes.chip}
                            key={index}
                            style={
                              {
                                // marginLeft: Number(item.quantity) > 1 ? 14 : 0
                              }
                            }
                            classes={{ badge: classes.badge }}
                            color="primary"
                            badgeContent={
                              item.quantity === undefined ? "" : item.quantity
                            }
                            invisible={Number(item.quantity) > 1 ? false : true}
                          >
                            <Chip
                              label={
                                item.itemName +
                                " | " +
                                item.itemPrice +
                                " | " +
                                item.itemTime +
                                " min"
                              }
                              color="default"
                            />
                          </Badge>
                        );
                    })
                  )}
                </div>
              </FormControl>
            </Grid>
            <Grid container item xs={12} sm={2} md={2} justify="flex-end">
              <div>
                <Link
                  to={{
                    pathname: `/order/detail/${_this.state.data.orderCode}`,
                    state: { prevPath: match.url },
                  }}
                >
                  <Button size="small" color="primary" variant="outlined">
                    {t("orders_editnote_detail")}
                  </Button>
                </Link>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_estimate_price")} />
                <PriceFormat value={_this.state.data.tempPrice} />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_membercard_money")} />
                <PriceFormat
                  value={
                    _this.state.data.calcMemberCards
                      ? `${_this.state.data.calcMemberCards} ${this.props.currencyCode}`
                      : `0 ${this.props.currencyCode}`
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_tax")} />
                <TextForm label={_this.state.data.tax * 100 + "%"} />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_value_discount")} />
                <PriceFormat value={valueDiscount} />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_voucher_money")} />
                <PriceFormat
                  value={
                    _this.state.data.voucher &&
                    _this.state.data.voucher.calcMoney
                      ? `${_this.state.data.voucher.calcMoney} ${this.props.currencyCode}`
                      : `0 ${this.props.currencyCode}`
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_total_price")} />
                <PriceFormat value={_this.state.data.totalPrice} />
              </FormControl>
            </Grid>
            <Divider className={classes.breakLine} />
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_money_received")} />
                <PriceFormat value={moneyReceived} />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_money_change")} />
                <PriceFormat value={moneyChange} />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4} />
            {/* <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_shipping_fee")} />
                <PriceFormat
                  value={`${_this.state.data.shippingFee} ${this.props.currencyCode}`}
                />
              </FormControl>
            </Grid> */}

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_customer_comment")} />
                <TextForm
                  label={
                    _this.state.data.customerComment ||
                    t("orders_editnote_none")
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_customer_note")} />
                <TextForm
                  label={_this.state.data.note || t("orders_editnote_none")}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_customer_feedback")} />
                {_this.state.data.feedback ? (
                  <div className={classes.emotionContainer}>
                    <img
                      className={classes.iconEmotion}
                      src={"/images/icon/" + _this.state.data.feedback + ".svg"}
                      alt="emotion"
                    />
                    <span
                      className={classNames(
                        classes.emotionText,
                        classes["" + _this.state.data.feedback]
                      )}
                    >
                      {t("nps_" + _this.state.data.feedback)}
                    </span>
                  </div>
                ) : (
                  <TextForm label={t("orders_editnote_none")} />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth variant="outlined">
                <LabelForm label={t("orders_editnote_history_order")} />
                <div className={classes.actionForm}>
                  {!actionHistory.length ? (
                    <div>{t("orders_editnote_not_any_action")}</div>
                  ) : (
                    actionHistory.map((action, index) => {
                      let employeeInfo = this.getInfoEmployee(action.userCode);
                      if (employeeInfo)
                        return (
                          <TextForm
                            key={index}
                            label={
                              t("orders_editnote_employee") +
                              " " +
                              employeeInfo.name +
                              " ( " +
                              employeeInfo.mobile +
                              ") " +
                              t("orders_editnote_changed_status") +
                              " " +
                              t(action.status) +
                              " " +
                              t("orders_editnote_for_this_order") +
                              " " +
                              this.changeFormat(action.time)
                            }
                            component="h2"
                            className={classes.actionLine}
                          />
                        );
                      else
                        return (
                          <TextForm
                            key={index}
                            label={
                              t("orders_editnote_owner") +
                              " " +
                              t("orders_editnote_changed_status") +
                              " " +
                              t(action.status) +
                              " " +
                              t("orders_editnote_for_this_order") +
                              " " +
                              this.changeFormat(action.time)
                            }
                            component="h2"
                            className={classes.actionLine}
                          />
                        );
                    })
                  )}
                </div>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      );
    } else {
      return <div></div>;
    }
  }
}

EditNote.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({
  orderDispatch: dispatch.order,
  employeeDispatch: dispatch.employees,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(textFieldStyles)(EditNote)));
